import React, { FC } from 'react';
import Arrow from '../../icons/Arrow';
import * as styles from './BackButton.module.scss';
import { navigate } from 'gatsby';

interface Props {
  buttonText: string;
}

const BackButton: FC<Props> = ({ buttonText }) => {
  return (
    <div className={styles.backButtonWrapper}>
      <a
        onClick={() => {
          navigate(-1);
        }}
        className={`${styles.backButton} ${styles.hover}`}
      >
        <Arrow
          direction="left"
          color={'black'}
        />
        {buttonText}
      </a>
    </div>
  );
};
export default BackButton;
